import { FormGroup, Validators, FormControl } from '@angular/forms';
import { Observable } from 'rxjs/internal/Observable';
import { of } from 'rxjs/internal/observable/of';
import { Formulario } from '../../interface/fomulario';

export class NewInscription implements Formulario {
    createFormulario(students: any[]): any[] {
        const formBuilt: any[] = [];
        const studentForm = {element: 'list', name: 'students', value: [], list: []};
        students.forEach((student: any, index) => {
            const elementAdd = {element: 'checkbox', name: 'student_' + index, label: student.fullname, value: student,
             validations: [], event: this.functionToExecute, typeEvent: 'click', checked: false
            };
            studentForm.list.push(elementAdd);
        });
        studentForm.list.push({element: 'radio', name: 'otro', label: 'Otro', value: 'otro', validations: [],
        event: this.functionToExecute, typeEvent: 'click', checked: false});
        formBuilt.push(studentForm);
        return formBuilt;
    }

    private functionToExecute(form: any[], formGroup: FormGroup, element: any, document?: any): Promise<any>{
        if (formGroup.value.students) {
            const i = formGroup.value.students.indexOf(element.name);
            if (i >= 0) {
                formGroup.value.students.splice(i, 1);
                form.forEach(el => {
                    el.list.map(check => {
                        if (check.name === element.name) {
                            check.checked = false;
                        }
                    });
                });
            } else {
                if (element.name === 'otro') {
                    formGroup.setControl('students', new FormControl(['otro'], []));
                    form.forEach(el => {
                        el.list.map(check => {
                            if (check.name !== 'otro') {
                                check.checked = false;
                                const index = formGroup.value.students.indexOf(check.name);
                                if (index >= 0) {
                                    formGroup.value.students.splice(index, 1);
                                }
                            }
                            if (check.name === 'otro') {
                                check.checked = true;
                            }
                        });
                    });
                } else {
                    const arr = formGroup.value.students;
                    arr.push(element.name);
                    formGroup.setControl('students', new FormControl(arr, []));
                    form.forEach(el => {
                        el.list.map(check => {
                            if (check.name === element.name) {
                                check.checked = (check.checked) ? false : true;
                            }
                            if (check.name === 'otro') {
                                check.checked = false;
                                const index = formGroup.value.students.indexOf('otro');
                                if (index >= 0) {
                                    formGroup.value.students.splice(index, 1);
                                }
                            }
                        });
                    });
                }
            }
        } else {
            const arr = [element.name];
            form.forEach(el => {
                el.list.map(check => {
                    if (check.name === element.name) {
                        check.checked = true;
                    }
                });
            });
            formGroup.setControl('students', new FormControl(arr, []));
        }
         // formGroup.setControl('students', new FormControl(['otro'], []));
         // formGroup.addControl('students', new FormControl([], []));
        return Promise.resolve(formGroup);

    }
}
